import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Link } from "react-router-dom";
// import campaignImg from './iir-landing-page.jpeg';
// import userLogo from './user_logo.jpeg'
import userLogo from './sunit.png'
import oneLinkQRCode from './onelinkQRcod.png'
import { UserIcon } from '../../../assets/images/campaign/UserIcon';
import { BookIcon } from '../../../assets/images/campaign/BookIcon';
import { DownloadMiniIcon } from '../../../assets/images/campaign/DownloadMiniIcon';
import { data } from "../../Data";
import apple_store from "../../../assets/images/app_store/apple_store.svg";
import play_store from "../../../assets/images/app_store/play_store.svg";
import { moengage } from '../../../utils/moengage';
import { leadNewUserInfo } from '../../../utils/lead-creation';
import { getOtp } from '../../../services/get-otp';
import { verifyOtp } from '../../../services/verify-otp';

const OTP_LENGTH = 6;
const TIMER_DURATION = 120; // 2 minutes in seconds

const Campaign = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  
  // 1. Form State
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    terms: false
  });

  // 2. Error State
  const [errors, setErrors] = useState({});

  // 3. OTP State
  const [otpSent, setOtpSent] = useState(false);
  const [otpValues, setOtpValues] = useState(Array(OTP_LENGTH).fill(''));
  const [otpError, setOtpError] = useState('');
  const [otpSuccess, setOtpSuccess] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [isSendingOtp, setIsSendingOtp] = useState(false);

  // 4. Timer State
  const [timer, setTimer] = useState(0);
  const timerRef = useRef(null);
  const otpInputRefs = useRef([]);

  
// Inside your main Form/Component:
const timerRefOtpTracker = useRef(null);

// Call this function when the user successfully clicks "Send OTP"
const handleSendOtpSuccess = async (data) => {
  await moengage.trackOtpSent(data);

  // Set absolute deadline (Current Time + 5 Minutes in Milliseconds)
  const deadline = Date.now() + 5 * 60 * 1000;
  localStorage.setItem('otp_deadline', deadline.toString());
  localStorage.setItem('otp_phone', data.phone);
  localStorage.setItem('otp_status', 'pending');

  startFrontendDroppedTimer(deadline, data.phone);
};

// Start or Resume the countdown
const startFrontendDroppedTimer = (deadline, phone) => {
  if (timerRefOtpTracker.current) clearTimeout(timerRefOtpTracker.current);

  const timeLeft = deadline - Date.now(); 

  if (timeLeft <= 0) {
    triggerDrop(phone);
  } else {
    timerRefOtpTracker.current = setTimeout(() => {
      triggerDrop(phone);
    }, timeLeft);
  }
};

const triggerDrop = async (phone) => {
  const status = localStorage.getItem('otp_status');
  if (status === 'pending') {
    await moengage.trackOtpDropped(phone);
    localStorage.setItem('otp_status', 'dropped');
    cleanOtpStorage();
  }
};

const handleVerificationSuccess = async () => {
  localStorage.setItem('otp_status', 'verified');
  if (timerRefOtpTracker.current) clearTimeout(timerRefOtpTracker.current);
  
  // await moengage.trackOtpVerified(data);
  cleanOtpStorage();
};

const cleanOtpStorage = () => {
  localStorage.removeItem('otp_deadline');
  localStorage.removeItem('otp_phone');
};

// --- HANDLE PAGE RELOADS ---
useEffect(() => {
  const savedDeadline = localStorage.getItem('otp_deadline');
  const savedPhone = localStorage.getItem('otp_phone');
  const savedStatus = localStorage.getItem('otp_status');

  // If a pending timer existed before the page was reloaded
  if (savedDeadline && savedPhone && savedStatus === 'pending') {
    const deadlineNum = parseInt(savedDeadline, 10);
    
    if (Date.now() < deadlineNum) {
      // User reloaded within the 5 minutes window -> Resume!
      startFrontendDroppedTimer(deadlineNum, savedPhone);
    } else {
      // User reloaded AFTER the 5 minutes expired -> Trigger drop immediately!
      triggerDrop(savedPhone);
    }
  }

  return () => { if (timerRefOtpTracker.current) clearTimeout(timerRefOtpTracker.current); };

  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

  const formatTime = (secs) => {
    const m = String(Math.floor(secs / 60)).padStart(2, '0');
    const s = String(secs % 60).padStart(2, '0');
    return `${m}:${s}`;
  };

  const startTimer = useCallback(() => {
    if (timerRef.current) clearInterval(timerRef.current);
    setTimer(TIMER_DURATION);
    timerRef.current = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  }, []);

  useEffect(() => () => clearInterval(timerRef.current), []);

  // 3. Validation Logic
  const validate = (data) => {
    const newErrors = {};

    // Name: At least 3 chars, letters and spaces only
    if (!data.fullName.trim()) {
      newErrors.fullName = "Full Name is required";
    } else if (!/^[a-zA-Z\s]{3,50}$/.test(data.fullName.trim())) {
      newErrors.fullName = "Please enter a valid name (min 3 letters)";
    }

    // Email: Standard RFC regex
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!data.email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(data.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    // Phone: exactly 10 digits
    const phoneClean = data.phone.replace(/\D/g, '');
    if (!phoneClean) {
      newErrors.phone = "Phone number is required";
    } else if (phoneClean.length !== 10) {
      newErrors.phone = "Please enter a valid 10-digit mobile number";
    }

    // Terms
    if (!data.terms) {
      newErrors.terms = "You must agree to the terms";
    }

    return newErrors;
  };

  const handleChange = (e) => {
  const { name, value, type, checked } = e.target;
  let val = type === 'checkbox' ? checked : value;

    // Field-specific length and character restrictions
    if (name === "phone") {
      val = value.replace(/\D/g, '').slice(0, 10); // digits only, max 10
    } else if (name === "fullName") {
      val = value.slice(0, 50); // max 50 characters
    } else if (name === "email") {
      val = value.slice(0, 100); // max 100 characters
    }

    // Update state once for all field types
    setFormData((prev) => ({ ...prev, [name]: val }));

    if (name === "phone" && otpSent) {
      setOtpSent(false);
      setOtpError('');
      if (timerRef.current) clearInterval(timerRef.current);
      setTimer(0);
    }

    // Clear error for a field when user starts typing again
    if (errors[name]) {
      setErrors((prev) => {
        const newErrs = { ...prev };
        delete newErrs[name];
        return newErrs;
      });
    }
  };

  const handleSendOtp = async () => {
    // Validate phone only
    const phoneClean = formData.phone.replace(/\D/g, '');
    if (!phoneClean || phoneClean.length !== 10) {
      setErrors((prev) => ({ ...prev, phone: 'Please enter a valid 10-digit mobile number' }));
      return;
    }
    try {
      setIsSendingOtp(true);
      await getOtp(phoneClean);
      setOtpSent(true);
      setOtpValues(Array(OTP_LENGTH).fill(''));
      setOtpError('');
      setOtpSuccess(false);
      startTimer();
      // Focus first OTP box after render
      setTimeout(() => otpInputRefs.current[0]?.focus(), 50);

      const sanitizedData = {
        ...formData,
        fullName: formData.fullName.trim(),
        phone: formData.phone.replace(/\D/g, '')
      };
      handleSendOtpSuccess(sanitizedData)

    } catch (err) {
      setErrors((prev) => ({ ...prev, phone: 'Failed to send OTP. Please try again.' }));
    } finally {
      setIsSendingOtp(false);
    }
  };

  const handleOtpChange = async (index, value) => {
    if (!/^\d*$/.test(value)) return; // digits only
    const newOtp = [...otpValues];
    newOtp[index] = value.slice(-1); // only last digit
    setOtpValues(newOtp);
    setOtpError('');

    // Move focus forward
    if (value && index < OTP_LENGTH - 1) {
      otpInputRefs.current[index + 1]?.focus();
    }

    // Auto-verify when all boxes filled
    const filled = newOtp.every((d) => d !== '');
    if (filled) {
      const otpString = newOtp.join('');
      const phoneClean = formData.phone.replace(/\D/g, '');
      try {
        setIsVerifying(true);
        await verifyOtp(phoneClean, otpString);
        setOtpSuccess(true);
        clearInterval(timerRef.current);
        // Proceed: moengage, lead creation, submit

        const sanitizedData = {
          ...formData,
          fullName: formData.fullName.trim(),
          phone: phoneClean
        };

        await moengage.trackOtpVerified(sanitizedData);

        handleVerificationSuccess()
        // await moengage.createProfile(sanitizedData);
        // await leadNewUserInfo(sanitizedData.email, sanitizedData.fullName, sanitizedData.phone, "");
        // setIsSubmitted(true);
        // handlePdfDownloadMethod();
      } catch (err) {
        setOtpError('Invalid OTP. Please try again.');
        setOtpValues(Array(OTP_LENGTH).fill(''));
        setTimeout(() => otpInputRefs.current[0]?.focus(), 50);
      } finally {
        setIsVerifying(false);
      }
    }
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otpValues[index] && index > 0) {
      otpInputRefs.current[index - 1]?.focus();
    }
  };

  const handleOtpPaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, OTP_LENGTH);
    if (!pasted) return;
    const newOtp = Array(OTP_LENGTH).fill('');
    pasted.split('').forEach((d, i) => { newOtp[i] = d; });
    setOtpValues(newOtp);
    const nextIndex = Math.min(pasted.length, OTP_LENGTH - 1);
    otpInputRefs.current[nextIndex]?.focus();
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    
    const validationErrors = validate(formData);
    
    if (Object.keys(validationErrors).length === 0) {
      const utm = {
        utm_source: "LP_PAID_IIR",
        utm_term: "IIR"
      }
      // Logic for sanitized data to send to API
      const sanitizedData = {
        ...formData,
        fullName: formData.fullName.trim(),
        phone: formData.phone.replace(/\D/g, '')
      };
      
      try{
        await moengage.downLoadStarterKitClicked(sanitizedData);
        let res = await leadNewUserInfo(sanitizedData.email, sanitizedData.fullName, sanitizedData.phone, utm);
        if(res?.status === 200){
          setIsSubmitted(true);
          handlePdfDownloadMethod();
        } else {
          console.error('Error Occured during lead creation: ', res)
        }
      } catch(error){
        console.error('Error Occured during lead creation: ', error)
      }
    } else {
      setErrors(validationErrors);
    }
  };

  const handlePdfDownloadMethod = () => {
    const link = document.createElement('a');
    link.href = '/personal_finance_kit.pdf'; 
    link.download = 'Personal Finance Starter Kit.pdf'; 
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); 
  }

  return (
    <>
      <section className="bg-[#2c5282] min-h-screen text-white pt-14 px-6 pb-6 md:p-12 lg:p-20 mt-10">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
          
          {/* Mobile-Only Image & Title - shows at order-1 on mobile, hides on desktop */}
          <div className="block lg:hidden space-y-8 order-1">
            <div className="rounded-2xl overflow-hidden border-2 border-white/10 max-w-md">
              <img fetchPriority='high' src={userLogo} alt="Hero" className="w-full h-auto" />
            </div>
            <h1 className="text-3xl/[1.2] md:text-5xl/[1.2] font-bold text-center">
              A Simple Plan to Reach <br />
              <span className="text-[#D9B08C]">₹1 Crore - Built for You!</span>
            </h1>
          </div>

          {/* Left Content Column (Paragraph etc. on mobile at order-3, full content on desktop at order-1) */}
          <div className="space-y-8 order-3 lg:order-1">
          {/* Hidden on mobile, visible on desktop */}
            <div className="hidden lg:block space-y-8">
              {/* ADDED: max-w-md (or max-w-sm/lg) to shrink the image container */}
              <div className="rounded-2xl overflow-hidden border-2 border-white/10 max-w-lg">
                <img fetchPriority='high' src={userLogo} alt="Hero" className="w-full h-auto" />
              </div>
              
              <h1 className="text-4xl/[1.2] md:text-5xl/[1.2] font-bold">
                A Simple Plan to Reach <br />
                <span className="text-[#D9B08C]">₹1 Crore - Built for You!</span>
              </h1>
            </div>
            
            <p className="text-lg text-gray-200 max-w-lg">
              A beginner-friendly personal finance starter kit designed for Indians 
              who want to stop guessing and start investing with confidence.
            </p>
            <div className="flex items-center justify-center md:items-start md:justify-start flex-wrap gap-4 text-sm text-gray-300">
              <span className="flex items-center gap-1"><UserIcon /> 30k+ Users</span>
              <span className="flex items-center gap-1"><BookIcon /> 3 Exercises</span>
              <span className="flex items-center gap-1"><DownloadMiniIcon /> Instant Access</span>
            </div>
          </div>

          {/* Right Form Column */}
          <div className="bg-[#f7ebdcf5] border-2 border-[#d4a574] rounded-3xl p-8 text-[#2D4A77] shadow-2xl h-full flex flex-col justify-center transition-all duration-500 min-h-[550px] order-2 lg:order-2">
            {isSubmitted ? (
              // Success Message UI (Kept your existing logic)
              <div className="flex flex-col items-center text-center animate-fade-in py-4">
                 <div className="w-16 h-16 bg-[#d4a574] rounded-full flex items-center justify-center mb-6 text-white shadow-md">
                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" /></svg>
                  </div>
                  <h2 className="text-[#2D4A77] font-bold text-3xl mb-3">Thank You!</h2>
                  <p className="text-[#2D4A77] font-bold mb-4">Download Our App Now</p>
                  <div className="bg-[#EADDCB] rounded-2xl p-6 border border-[#d4a574]/30 shadow-inner w-full flex flex-col items-center max-w-[280px]">
                    <div className="bg-white p-3 rounded-xl mb-3 shadow-sm">
                      <img src={oneLinkQRCode} alt="QR Code" className="w-[140px] h-[140px]" />
                    </div>
                    <p className="text-[#2D4A77] font-bold text-[15px]">Scan to Download</p>
                    <p className="text-[#2D4A77] opacity-70 text-[11px] mt-0.5">Available on iOS & Android</p>
                  </div>
                  <div className="flex justify-center gap-4 mt-10">
                    <a href={data.google_play_store}><img src={play_store} alt="Play Store" className="h-[42px]" /></a>
                    <a href={data.apple_store}><img src={apple_store} alt="App Store" className="h-[42px]" /></a>
                  </div>
              </div>
            ) : (
              <div className="animate-fade-in transition-all duration-500">
                <div className="text-center mb-8">
                  <h2 className="text-2xl font-bold">Get Your Free Starter Kit</h2>
                  <p className="text-sm opacity-80">Fill in your details to download instantly</p>
                </div>
                
                <form className="space-y-4" onSubmit={handleSubmit} noValidate>
                  {/* Name Input */}
                  <div>
                    <label className="block text-sm mb-1 font-semibold">Full Name *</label>
                    <input 
                      type="text" 
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleChange}
                      placeholder="Enter your full name" 
                      className={`w-full p-3 rounded-lg border outline-none transition-all ${errors.fullName ? 'border-red-500 bg-red-50' : 'border-gray-300 focus:ring-2 focus:ring-blue-500'}`}
                    />
                    {errors.fullName && <p className="text-red-500 text-xs mt-1 font-medium">{errors.fullName}</p>}
                  </div>
                  
                  {/* Email Input */}
                  <div>
                    <label className="block text-sm mb-1 font-semibold">Email Address *</label>
                    <input 
                      type="email" 
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="your.email@example.com" 
                      className={`w-full p-3 rounded-lg border outline-none transition-all ${errors.email ? 'border-red-500 bg-red-50' : 'border-gray-300 focus:ring-2 focus:ring-blue-500'}`}
                    />
                    {errors.email && <p className="text-red-500 text-xs mt-1 font-medium">{errors.email}</p>}
                  </div>
                  
                  {/* Phone Input */}
                  <div>
                    <label className="block text-sm mb-1 font-semibold">Contact Number *</label>
                  <div className="flex w-full text-[#2D4A77]">
                    <span className="flex items-center justify-center px-4 font-bold text-black border border-gray-300 border-r-0 bg-gray-50 rounded-l-lg">
                      +91
                    </span>
                    <input 
                      type="tel" 
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="0000000000" 
                      disabled={otpSuccess || isSendingOtp || (otpSent && !otpError && timer > 0)}
                      className={`flex-1 p-3 rounded-r-lg rounded-l-none border outline-none transition-all ${errors.phone ? 'border-red-500 bg-red-50' : 'border-gray-300 focus:ring-2 focus:ring-blue-500 focus:z-10'} disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed`}
                    />
                  </div>
                  <div className="flex items-end justify-between">
                    {errors.phone && <p className="text-red-500 text-xs mt-1 font-medium">{errors.phone}</p>}
                  </div>
                  {otpSuccess ? (
                    /* ✅ Verified — replace button with badge */
                    <span className="ml-auto flex items-center gap-1 font-semibold text-green-600 mt-2 text-[15px]">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      Mobile No. verified
                    </span>
                  ) : (
                    <button
                      type="button"
                      onClick={handleSendOtp}
                      disabled={timer > 0 || isSendingOtp}
                      className={`mt-2 mr-auto font-semibold transition-all ${
                        timer > 0 || isSendingOtp
                          ? 'text-[15px] text-gray-400 cursor-not-allowed'
                          : 'text-[15px] text-blue-600 cursor-pointer hover:text-blue-800'
                      }`}
                    >
                      {isSendingOtp ? 'Sending…' : otpSent ? 'Resend OTP' : 'Send OTP'}
                    </button>
                  )}

                  {/* OTP Fields Block — hidden once verified */}
                  {otpSent && !otpSuccess && (
                    <div className="mt-0 mb-2 animate-fade-in">
                      {/* Header: label + timer */}
                      <div className="flex items-center justify-between mb-3">
                        {timer > 0 && (
                          <span className="text-sm font-bold tabular-nums" style={{ color: timer <= 30 ? '#ef4444' : '#2D4A77' }}>
                            Expires In: {formatTime(timer)}
                          </span>
                        )}
                        {/* <p className="text-xs font-semibold text-[#2D4A77] uppercase tracking-wide">
                          Verify Your OTP
                        </p> */}
                      </div>

                      {/* 6 OTP Boxes */}
                      <div className="flex gap-2 justify-center" onPaste={handleOtpPaste}>
                        {otpValues.map((digit, idx) => (
                          <input
                            key={idx}
                            ref={(el) => (otpInputRefs.current[idx] = el)}
                            type="tel"
                            inputMode="numeric"
                            maxLength={1}
                            value={digit}
                            onChange={(e) => handleOtpChange(idx, e.target.value)}
                            onKeyDown={(e) => handleOtpKeyDown(idx, e)}
                            disabled={isVerifying}
                            className={`w-10 h-12 text-center text-lg font-bold rounded-lg border-2 outline-none transition-all
                              ${
                                otpError
                                  ? 'border-red-400 bg-red-50 text-red-600'
                                  : digit
                                  ? 'border-blue-500 bg-blue-50 text-[#2D4A77]'
                                  : 'border-gray-300 bg-white text-[#2D4A77] focus:border-blue-500 focus:ring-2 focus:ring-blue-200'
                              }`
                            }
                            style={{ WebkitAppearance: 'none', MozAppearance: 'textfield' }}
                          />
                        ))}
                      </div>

                      {/* Status messages */}
                      {isVerifying && (
                        <p className="text-xs text-blue-500 mt-2 flex items-center gap-1">
                          <svg className="animate-spin w-3 h-3" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
                          </svg>
                          Verifying…
                        </p>
                      )}
                      {otpError && (
                        <p className="text-red-500 text-xs mt-2 font-medium">{otpError}</p>
                      )}
                      {timer === 0 && !otpSuccess && (
                        <p className="text-red-500 text-xs mt-6 font-medium">OTP expired. Click Resend OTP.</p>
                      )}
                    </div>
                  )}

                  </div>
                  
                  {/* Terms Checkbox */}
                  <div className="py-2">
                    <div className="flex items-start gap-2">
                      <input 
                        type="checkbox" 
                        name="terms"
                        checked={formData.terms}
                        onChange={handleChange}
                        className="mt-1 accent-[#2D4A77]" 
                        id="terms" 
                      />
                      <label htmlFor="terms" className="block text-sm">I agree to the <Link className='font-bold hover:underline cursor-pointer' to="/term-of-service">Terms of service</Link> and <Link className='font-bold hover:underline cursor-pointer' to="/privacy-policy">Privacy Policy</Link></label>
                    </div>
                    {errors.terms && <p className="text-red-500 text-xs mt-1 font-medium">{errors.terms}</p>}
                  </div>
                  
                  {/* Download button — enabled only when OTP verified + name + email filled */}
                  {(() => {
                    const canSubmit =
                      otpSuccess &&
                      formData.fullName.trim().length >= 3 &&
                      formData.email.trim().length > 0;
                    return (
                      <button
                        type="submit"
                        disabled={!canSubmit}
                        className={`w-full py-4 rounded-xl font-bold flex items-center justify-center gap-2 transition-all shadow-lg ${
                          canSubmit
                            ? 'bg-[#2D4A77] text-white hover:bg-blue-900 active:scale-95 cursor-pointer'
                            : 'bg-gray-200 text-gray-400 cursor-not-allowed shadow-none'
                        }`}
                      >
                        <DownloadIcon />
                        Download Free Starter Kit
                      </button>
                    );
                  })()}
                </form>

                <div className="mt-8 text-center space-y-4">
                  <p className="text-sm font-bold">Download Our App</p>
                  <div className="flex justify-center gap-4">
                     <a href={data.google_play_store || '#'}><img src={play_store} alt="Google Play" className="h-[42px] object-contain" /></a>
                     <a href={data.apple_store || '#'}><img src={apple_store} alt="App Store" className="h-[42px] object-contain" /></a>
                  </div>
                  <p className="text-[12px] opacity-60">🔒 Your information is 100% secure and will never be shared</p>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="max-w-7xl mx-auto mt-16 lg:mt-24">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">What You'll Get</h2>
          <p className="text-gray-300">Everything you need to start investing in India</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Card 1 */}
          <div className="bg-[#E8DBC9] border border-white/5 shadow-lg rounded-2xl p-6 transition-transform hover:-translate-y-1">
            <div className="bg-[#D9B08C] text-[#2D4A77] w-12 h-12 rounded-xl flex items-center justify-center mb-6">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" /></svg>
            </div>
            <h3 className="text-lg font-bold mb-2 text-[#001e5A]">Budgeting Template</h3>
            <p className="text-sm text-[#001e5A]">India focused budget planner for rent, groceries & EMIs</p>
          </div>

          {/* Card 2 */}
          <div className="bg-[#E8DBC9] border border-white/5 shadow-lg rounded-2xl p-6 transition-transform hover:-translate-y-1">
            <div className="bg-[#D9B08C] text-[#2D4A77] w-12 h-12 rounded-xl flex items-center justify-center mb-6">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" /></svg>
            </div>
            <h3 className="text-lg font-bold mb-2 text-[#001e5A]">First Investment Plan</h3>
            <p className="text-sm text-[#001e5A]">Simple SIP strategy + beginner stock picks</p>
          </div>

          {/* Card 3 */}
          <div className="bg-[#E8DBC9] border border-white/5 shadow-lg rounded-2xl p-6 transition-transform hover:-translate-y-1">
            <div className="bg-[#D9B08C] text-[#2D4A77] w-12 h-12 rounded-xl flex items-center justify-center mb-6">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" /></svg>
            </div>
            <h3 className="text-lg font-bold mb-2 text-[#001e5A]">Common Mistakes to Avoid</h3>
            <p className="text-sm text-[#001e5A]">Learn from others - avoid top 10 beginner pitfalls</p>
          </div>

          {/* Card 4 */}
          <div className="bg-[#E8DBC9] border border-white/5 shadow-lg rounded-2xl p-6 transition-transform hover:-translate-y-1">
            <div className="bg-[#D9B08C] text-[#2D4A77] w-12 h-12 rounded-xl flex items-center justify-center mb-6">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
            </div>
            <h3 className="text-lg font-bold mb-2 text-[#001e5A]">90-Day Action Plan</h3>
            <p className="text-sm text-[#001e5A]">Day-by-day roadmap to your first investment</p>
          </div>
        </div>
      </div>
    </section>
      
      {/* Scanner Section */}
      <section className="bg-[#E8DBC9] text-[#2D4A77] py-16 md:py-24 px-6 md:px-12 lg:px-20 relative overflow-hidden">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-evenly gap-12 lg:gap-16 relative z-10">
          
          {/* Left Text — centered on mobile, left-aligned on desktop */}
          <div className="flex-1 space-y-6 max-w-2xl text-center lg:text-left w-full">
            <h1 className="text-3xl/[1.2] md:text-4xl/[1.2] lg:text-5xl/[1.2] font-bold">
              Your First Smart Money Move Starts Here !
            </h1>
            <p className="text-base md:text-lg opacity-90 max-w-md mx-auto lg:mx-0">
              Join 30000+ Indians who took control of their financial future. Download your free starter kit now.
            </p>
            
            <div className="pt-2 space-y-3 flex flex-col items-center lg:items-start">
              <button
                onClick={() => {
                  if (isSubmitted) {
                    handlePdfDownloadMethod();
                  } else {
                    const canSubmit =
                      otpSuccess &&
                      formData.fullName.trim().length >= 3 &&
                      formData.email.trim().length > 0;
                    if(canSubmit){
                      handleSubmit();
                    } 
                    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

                  }
                }}
                className="bg-[#2D4A77] text-white py-4 px-8 rounded-xl font-bold flex items-center justify-center gap-3 hover:bg-blue-900 transition-colors shadow-lg shadow-blue-900/20 text-base md:text-lg w-fit"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" /></svg>
                Download Free Starter Kit
              </button>
              
              <p className="text-sm opacity-60 flex items-center gap-2 font-medium">
                ⏱️ Takes less than 2 minutes
              </p>
            </div>
          </div>

          {/* Right Scanner Card — centered on mobile */}
          <div className="bg-white rounded-3xl p-8 md:p-10 shadow-2xl flex-shrink-0 w-full max-w-[380px] flex flex-col items-center border border-white relative mx-auto lg:mx-0">
            <h3 className="text-[#2D4A77] font-extrabold text-2xl mb-1">Scan to Download</h3>
            <p className="text-sm opacity-60 mb-8 font-medium">Get instant access on your phone</p>
            
            <div className="mb-8">
              <img src={oneLinkQRCode} alt="QR Code" className="w-[200px] h-[200px]" />
            </div>
            
            <div className="w-full flex items-center border-t border-gray-100 pt-6">
              <div className="bg-[#F5E6D3] rounded-xl px-4 py-3 text-center flex-1 mr-4">
                <p className="font-extrabold text-2xl text-[#2D4A77]">30000+</p>
                <p className="text-[10px] font-bold uppercase tracking-widest opacity-60 mt-1">Downloads</p>
              </div>
              <div className="text-center flex-1 px-4 py-3">
                <p className="font-extrabold text-2xl text-[#2D4A77] flex items-center justify-center gap-1.5">
                  4.4 <span className="text-[#FFC107] text-xl">★</span>
                </p>
                <p className="text-[10px] font-bold uppercase tracking-widest opacity-60 mt-1">Rating</p>
              </div>
            </div>
          </div>
          
        </div>
        
        {/* Subtle background glow effect similar to the figma styling */}
        <div className="absolute top-1/2 right-0 -translate-y-1/2 translate-x-1/4 w-[800px] h-[800px] bg-black/5 rounded-full blur-3xl pointer-events-none"></div>
      </section>
    </>
  );
};

// Helper internal component for the button icon
const DownloadIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" x2="12" y1="15" y2="3"/></svg>
);

export default Campaign;